const generateLink = (isCorpView: boolean, customerNumber: string, path: string) => {
  return isCorpView
    ? `/corp/practice/${customerNumber}/${path}`
    : `/practice/${path}`
}

export default generateLink
